var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5248_727",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 11,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49992 5.91667C7.69654 5.91667 8.66659 4.94662 8.66659 3.75C8.66659 2.55338 7.69654 1.58333 6.49992 1.58333C5.3033 1.58333 4.33325 2.55338 4.33325 3.75C4.33325 4.94662 5.3033 5.91667 6.49992 5.91667Z",
    fill: "#555555",
    stroke: "white",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 12.4167C11.375 9.72431 9.19235 7.54167 6.5 7.54167C3.80765 7.54167 1.625 9.72431 1.625 12.4167",
    stroke: "white",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50008 12.4167L7.58341 11.0625L6.50008 7.54167L5.41675 11.0625L6.50008 12.4167Z",
    fill: "#555555",
    stroke: "white",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5248_727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H13V13.5H0V0.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.28a836d2e5af5fad73dfe6832f1f6140.svg";
export { ForwardRef as ReactComponent };